const headers = {
  name: "Receipt",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Receipt",
        path: "",
      }
    ],
  },
};

export default headers;
